import type { MessageKey } from "../shell/i18n";
import type { Locale } from "../shell/i18n/locales";

export type ProductMessages = Record<MessageKey, string>;

/** Load exactly the language the product is about to render. */
export async function productMessages(locale: Locale): Promise<ProductMessages> {
  switch (locale) {
    case "en":
      return (await import("../shell/i18n/catalogue.en")).en;
    case "tr":
      return (await import("../shell/i18n/catalogue.tr")).tr;
  }
}
